/**
 * @file theme-extras.ts
 * @description Плотность отступов сайта числом (phase19.16 Р1, §7.13 файла
 * фазы «Отступы»; SB120 этап 2 — uiux-sb120-stage2 §2, db-design-sb120-stage2
 * §4): `theme.spacing.density` — множитель шкалы отступов 0,5–1,6. Прежние
 * ступени «Компактно / Обычно / Просторно» — подсказки 0,8 / 1 / 1,25
 * (`DENSITY_PRESETS`, appearance-numbers.ts).
 */

import { SITE_THEME_LIMITS, type SiteSpacingDensity, type SiteTheme } from "@chaiberi/shared";

export type SiteDensity = SiteSpacingDensity;

const { density: LIMITS } = SITE_THEME_LIMITS;

/** Плотность документа: число в пределах; нет раздела или битое значение — 1 («Обычно»). */
export function readDensity(theme: SiteTheme): SiteDensity {
  const value: unknown = (theme as Partial<SiteTheme>).spacing?.density;
  return typeof value === "number" && Number.isFinite(value) && value >= LIMITS.min && value <= LIMITS.max
    ? value
    : LIMITS.default;
}

/** Новый документ с выбранной плотностью (в пределах схемы). */
export function withDensity(theme: SiteTheme, density: SiteDensity): SiteTheme {
  const clamped = Math.min(LIMITS.max, Math.max(LIMITS.min, density));
  return { ...theme, spacing: { ...theme.spacing, density: clamped } };
}
